import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faClock,
  faCircleCheck,
  faCalendarDays,
  faMoneyBillWave,
} from '@fortawesome/free-solid-svg-icons';
import {
  StatsGrid,
  StatCard,
  StatIconWrap,
  StatValue,
  StatLabel,
  StatHelp,
} from './Styles';
import { STAT_LABELS } from './constants';

const STAT_ITEMS = [
  {
    key: 'pending',
    icon: faClock,
    label: STAT_LABELS.PENDING,
    help: STAT_LABELS.PENDING_HELP,
    color: '#f59e0b',
    value: 'N/A',
  },
  {
    key: 'cleared',
    icon: faCircleCheck,
    label: STAT_LABELS.CLEARED,
    help: STAT_LABELS.CLEARED_HELP,
    color: '#22c55e',
    value: 'N/A',
  },
  {
    key: 'upcoming',
    icon: faCalendarDays,
    label: STAT_LABELS.UPCOMING,
    help: STAT_LABELS.UPCOMING_HELP,
    color: '#3b82f6',
    value: 'N/A',
  },
  {
    key: 'total',
    icon: faMoneyBillWave,
    label: STAT_LABELS.TOTAL,
    help: STAT_LABELS.TOTAL_HELP,
    color: '#ef4444',
    value: 'N/A',
  },
];

const StatsCards: React.FC = () => {
  return (
    <StatsGrid>
      {STAT_ITEMS.map((item) => (
        <StatCard key={item.key} size="small">
          <StatIconWrap $color={item.color}>
            <FontAwesomeIcon icon={item.icon} />
          </StatIconWrap>
          <StatValue>{item.value}</StatValue>
          <StatLabel>{item.label}</StatLabel>
          <StatHelp $color={item.color}>{item.help}</StatHelp>
        </StatCard>
      ))}
    </StatsGrid>
  );
};

export default React.memo(StatsCards);
